module.exports = __webpack_public_path__ + "img/21600.6bd8bb18.jpg";